import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { useBEM } from "@geome/react-next/lib/hooks/useBEM";
import { useCallOnKeyPress } from "../../hooks/callOnKeyPress/useCallOnKeyPress";
import { CollapsibleIcon } from "./collapsibleIcon";
export const TitleForSectionWithTitle = ({ collapsible, onClick, id, open, sectionTokenPath, renderIcon, titleArgs, }) => {
    const { translate } = useI18n();
    const isCollapsible = Boolean(collapsible);
    const titleId = `${id}-title`;
    const titleClassname = useBEM({
        block: "section-with-title",
        element: "title",
        modifiers: {
            collapsible: isCollapsible,
        },
    });
    const sectionTitle = translate(`${sectionTokenPath}.title`, titleArgs);
    const onKeyPress = useCallOnKeyPress(onClick, ["Enter", " "]);
    if (collapsible) {
        return (_jsxs("h2", { onClick: onClick, tabIndex: 0, onKeyPress: onKeyPress, className: titleClassname, id: titleId, role: "button", "aria-label": open
                ? translate(`aria.close_section`, { sectionTitle })
                : translate(`aria.open_section`, { sectionTitle }), children: [renderIcon && renderIcon(), " ", sectionTitle, _jsx(CollapsibleIcon, { open: open, renderIcon: typeof collapsible === "object" ? collapsible.renderIcon : undefined })] }));
    }
    return (_jsxs("h2", { className: titleClassname, id: titleId, children: [renderIcon && renderIcon(), " ", sectionTitle] }));
};
